import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs/Subscription';
import { environment } from '../../../../environments/environment';
import { CompanyDataService } from '../../../@core/services/company-data.service';
import { ICompanyData } from '../../layouts';

@Component({
  selector: 'ngx-footer',
  styleUrls: ['./footer.component.scss'],
  template: `
    <span class="created-by">Created by <b><a href="{{companyData?.url || '#'}}" target="_blank">{{companyData?.text || 'FTM'}}</a></b> {{companyData?.year || '2021'}} </span><span
      style="font-size:0.6em; float:right">V{{version}}</span>
    <!--<div class="socials">-->
      <!--<a href="#" target="_blank" class="ion ion-social-github"></a>-->
      <!--<a href="#" target="_blank" class="ion ion-social-facebook"></a>-->
      <!--<a href="#" target="_blank" class="ion ion-social-twitter"></a>-->
      <!--<a href="#" target="_blank" class="ion ion-social-linkedin"></a>-->
    <!--</div>-->
  `,
})
export class FooterComponent implements OnInit, OnDestroy {
  public version: string = environment.VERSION;
  companyData: ICompanyData | null = null;
  private subscription: Subscription = new Subscription();

  constructor(private companyDataService: CompanyDataService) {}

  ngOnInit(): void {
    this.subscription.add(
      this.companyDataService.getCompanyData().subscribe(
        (data: ICompanyData) => {
          this.companyData = data;
        },
        (error) => {
          console.error('Failed to load company data in footer:', error);
          // Don't set default values - let the template handle it with fallbacks
        },
      ),
    );
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}



// WEBPACK FOOTER //
// ./src/app/@theme/components/footer/footer.component.ts